<template>
  <div class="orcamento-cabecalho">
    <div class="orcamento-cabecalho__top">
      <div class="orcamento-cabecalho__title-wrap">
        <span class="orcamento-cabecalho__icon">
          <i class="fa fa-file-text-o"></i>
        </span>
        <h2 class="orcamento-cabecalho__title">Orçamento #{{ id }}</h2>
        <span
          v-if="statusMeta"
          class="orcamento-cabecalho__status"
          :class="'orcamento-cabecalho__status--' + statusMeta.variant"
        >
          <span class="orcamento-cabecalho__status-dot"></span>
          {{ statusMeta.text }}
        </span>
      </div>
      <div class="orcamento-cabecalho__actions">
        <b-button
          size="sm"
          class="orcamento-cabecalho__btn orcamento-cabecalho__btn--outline"
          v-on:click="$emit('voltar')"
        >
          <i class="fa fa-arrow-left"></i> Voltar
        </b-button>
        <b-button
          v-if="showDuplicar"
          size="sm"
          class="orcamento-cabecalho__btn orcamento-cabecalho__btn--outline"
          v-on:click="$emit('duplicar')"
        >
          <i class="fa fa-copy"></i> Duplicar
        </b-button>
        <b-button
          v-if="showImprimir"
          size="sm"
          class="orcamento-cabecalho__btn orcamento-cabecalho__btn--solid"
          v-on:click="$emit('imprimir')"
        >
          <i class="fa fa-print"></i> Gerar Proposta
        </b-button>
      </div>
    </div>
    <div class="orcamento-cabecalho__info">
      <div class="orcamento-cabecalho__info-item orcamento-cabecalho__info-item--codigo">
        <div class="orcamento-cabecalho__label">
          <i class="fa fa-hashtag"></i> Código
        </div>
        <div class="orcamento-cabecalho__codigo-row">
          <div class="orcamento-cabecalho__value">{{ displayValue(codigo) }}</div>
          <cliente-status
            v-if="statusCliente"
            id="statusClienteCabecalho"
            :status="statusCliente"
          />
        </div>
        <div v-if="razaoSocial" class="orcamento-cabecalho__razao">
          {{ razaoSocial }}
        </div>
      </div>
      <div class="orcamento-cabecalho__info-item">
        <div class="orcamento-cabecalho__label">
          <i class="fa fa-calendar"></i> Emissão
        </div>
        <div class="orcamento-cabecalho__value">{{ displayDate(dataEmissao) }}</div>
      </div>
      <div class="orcamento-cabecalho__info-item">
        <div class="orcamento-cabecalho__label">
          <i class="fa fa-calendar"></i> Validade
        </div>
        <div class="orcamento-cabecalho__value">{{ displayDate(dataValidade) }}</div>
      </div>
      <div class="orcamento-cabecalho__info-item">
        <div class="orcamento-cabecalho__label">
          <i class="fa fa-calendar"></i> Prev. Fechamento
        </div>
        <div class="orcamento-cabecalho__value">
          <slot name="previsao">{{ displayDate(previsaoFechamento) }}</slot>
        </div>
      </div>
      <div class="orcamento-cabecalho__info-item">
        <div class="orcamento-cabecalho__label">
          <i class="fa fa-user"></i> Contato
        </div>
        <div class="orcamento-cabecalho__value">
          <slot name="contato">{{ displayValue(contato) }}</slot>
        </div>
      </div>
      <div class="orcamento-cabecalho__info-item">
        <div class="orcamento-cabecalho__label">
          <i class="fa fa-building"></i> CNPJ
        </div>
        <div class="orcamento-cabecalho__value">{{ displayCnpj(cnpj) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Moment from "moment";
import ClienteStatus from "../clientes/ClienteStatus";

export default {
  name: "OrcamentoCabecalho",
  components: {
    ClienteStatus,
  },
  props: {
    id: {
      type: [String, Number],
      default: "",
    },
    status: {
      type: String,
      default: "",
    },
    codigo: {
      type: [String, Number],
      default: "",
    },
    razaoSocial: {
      type: String,
      default: "",
    },
    statusCliente: {
      type: String,
      default: "",
    },
    dataEmissao: {
      type: String,
      default: "",
    },
    dataValidade: {
      type: String,
      default: "",
    },
    previsaoFechamento: {
      type: String,
      default: "",
    },
    contato: {
      type: String,
      default: "",
    },
    cnpj: {
      type: String,
      default: "",
    },
    showDuplicar: {
      type: Boolean,
      default: true,
    },
    showImprimir: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    statusMeta() {
      if (this.status == null || this.status === "") {
        return null;
      }
      switch (this.status) {
        case "C":
          return { text: "Cancelado", variant: "danger" };
        case "I":
          return { text: "Finalizado", variant: "success" };
        default:
          return { text: "Aberto", variant: "primary" };
      }
    },
  },
  methods: {
    displayValue(value) {
      if (value === null || value === undefined || value === "") {
        return "—";
      }
      return value;
    },
    displayDate(value) {
      if (!value) {
        return "—";
      }
      const date = Moment(String(value));
      if (!date.isValid()) {
        return "—";
      }
      return date.format("DD/MM/YYYY");
    },
    displayCnpj(value) {
      if (!value) {
        return "—";
      }
      const digits = String(value).padStart(14, "0");
      return digits.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    },
  },
};
</script>

<style scoped>
.orcamento-cabecalho {
  border: none;
  border-bottom: 1px solid #e4e7ea;
  border-radius: 0;
  overflow: hidden;
  margin-bottom: 0;
  background: #fff;
}

.orcamento-cabecalho__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  background: #5804CA;
  padding: 0.85rem 1.1rem;
}

.orcamento-cabecalho__title-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  min-width: 0;
}

.orcamento-cabecalho__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  flex-shrink: 0;
}

.orcamento-cabecalho__title {
  margin: 0;
  color: #fff;
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.2;
}

.orcamento-cabecalho__status {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.2rem 0.7rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.3;
}

.orcamento-cabecalho__status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.orcamento-cabecalho__status--danger {
  background: #fde8e8;
  color: #c62828;
}

.orcamento-cabecalho__status--danger .orcamento-cabecalho__status-dot {
  background: #c62828;
}

.orcamento-cabecalho__status--success {
  background: #e6f6ed;
  color: #1b7a45;
}

.orcamento-cabecalho__status--success .orcamento-cabecalho__status-dot {
  background: #1b7a45;
}

.orcamento-cabecalho__status--primary {
  background: #e5f1ff;
  color: #005bb7;
}

.orcamento-cabecalho__status--primary .orcamento-cabecalho__status-dot {
  background: #0075eb;
}

.orcamento-cabecalho__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.orcamento-cabecalho__btn {
  border-radius: 6px;
  font-weight: 600;
}

.orcamento-cabecalho__btn--outline {
  background: transparent !important;
  border: 1px solid rgba(255, 255, 255, 0.75) !important;
  color: #fff !important;
}

.orcamento-cabecalho__btn--outline:hover,
.orcamento-cabecalho__btn--outline:focus {
  background: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}

.orcamento-cabecalho__btn--solid {
  background: #fff !important;
  border: 1px solid #fff !important;
  color: #0075eb !important;
}

.orcamento-cabecalho__btn--solid:hover,
.orcamento-cabecalho__btn--solid:focus {
  background: #f3f8ff !important;
  color: #005bb7 !important;
}

.orcamento-cabecalho__info {
  display: grid;
  grid-template-columns: minmax(200px, 1.7fr) repeat(5, minmax(110px, 1fr));
  background: #fff;
}

.orcamento-cabecalho__codigo-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.orcamento-cabecalho__info-item {
  padding: 0.85rem 1rem;
  border-right: 1px solid #edf0f2;
  min-width: 0;
}

.orcamento-cabecalho__info-item:last-child {
  border-right: none;
}

.orcamento-cabecalho__label {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  color: #8a94a6;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 0.35rem;
}

.orcamento-cabecalho__label i {
  font-size: 0.7rem;
}

.orcamento-cabecalho__value {
  color: #23282c;
  font-size: 0.98rem;
  font-weight: 700;
  line-height: 1.3;
  word-break: break-word;
}

.orcamento-cabecalho__razao {
  margin-top: 0.2rem;
  color: #0075eb;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.3;
  word-break: break-word;
}

.orcamento-cabecalho__codigo-row >>> .badge {
  font-size: 0.7rem;
  padding: 0.3em 0.55em;
}

.orcamento-cabecalho__value >>> .form-control,
.orcamento-cabecalho__value >>> input {
  font-weight: 600;
  font-size: 0.9rem;
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
}

@media (max-width: 991.98px) {
  .orcamento-cabecalho__info {
    grid-template-columns: 1fr 1fr;
  }

  .orcamento-cabecalho__info-item {
    border-right: none;
    border-bottom: 1px solid #edf0f2;
  }

  .orcamento-cabecalho__info-item:nth-child(odd) {
    border-right: 1px solid #edf0f2;
  }

  .orcamento-cabecalho__info-item:nth-last-child(-n + 2) {
    border-bottom: none;
  }
}

@media (max-width: 575.98px) {
  .orcamento-cabecalho__info {
    grid-template-columns: 1fr;
  }

  .orcamento-cabecalho__info-item,
  .orcamento-cabecalho__info-item:nth-child(odd) {
    border-right: none;
    border-bottom: 1px solid #edf0f2;
  }

  .orcamento-cabecalho__info-item:last-child {
    border-bottom: none;
  }
}
</style>
